
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayDigitalOpen as ObiThreewayDigitalOpenElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-digital-open.js';
 
 
 

 
 export const ObiThreewayDigitalOpen = createComponent({
   react: React,
   tagName: 'obi-threeway-digital-open',
   elementClass: ObiThreewayDigitalOpenElement,
   events: {
     
   }
  });
 
 